import api from '@/services/api'

export default class EvaluationAPI {
  static EVALUATION_ENDPOINT = 'evaluations'
  /**
   * Initialize a `EvaluationAPI` instance.
   *
   * @param {class} cls  The class to use to create application objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `EvaluationAPI`.
   *
   * @param {class} cls      The class to use to create application objects.
   **/
  static create(cls) {
    return new EvaluationAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one application from the API.
   *
   * @param {String} evaluationId  Unique ID of the application to retrieve.
   */
  get(evaluationId) {
    const url = `${EvaluationAPI.EVALUATION_ENDPOINT}/${evaluationId}/`
    var dataToReturn =  this.client.get(url).then(response => this.cls.fromAPI(response.data))
    return dataToReturn
  }

  /**
   * Get all application through the API.
   *
   *
   */
  // eslint-disable-next-line no-unused-vars
  list({ filters = {} } = {}) {
    const url = `${EvaluationAPI.EVALUATION_ENDPOINT}/`
    const options = {
      params: {},
    }
    if (filters.evaluator) {
      options.params.evaluator = filters.evaluator
    }
    if (filters.pageSize) {
      options.params.page_size = filters.pageSize
    }
    var dataToReturn =  this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => { 
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })

      return dataToReturn;
  }

  /**
   * Update a application through the API.
   *
   * @param {application} application data to send to the API.
   */
  update(evaluation, fields = [], excludeFields = []) {
    const url = `${EvaluationAPI.EVALUATION_ENDPOINT}/${evaluation.id}/`
    const data = this.cls.toAPI(evaluation, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }
}
